import { render } from "./History.vue?vue&type=template&id=2aea4c49"
import script from "./History.vue?vue&type=script&lang=ts"
export * from "./History.vue?vue&type=script&lang=ts"
script.render = render

export default script